import {css} from '@emotion/css';
import React, {useCallback, useContext, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, Modal} from '@veneer/core';

import {BuyOrActivateLicenseContext} from '../BuyOrActivateLicense';
import {LicenseImportSteps} from '../LicenseImportSteps';

const ImportLicensesModal = (): JSX.Element => {
    const {t} = useTranslation(['licenses']);
    const {showBuyActivateLinks} = useContext(BuyOrActivateLicenseContext);

    const [open, setOpen] = useState(false);

    const toggleModal = useCallback(() => setOpen(!open), [open]);

    const importLicensesLabel = useMemo(() => t('licenses:importLicenses', 'Import licenses'), [t]);

    const classNames = useMemo(
        () => ({
            modal: css({
                ['[role="dialog"]']: {
                    width: '600px',
                },
            }),
        }),
        []
    );

    if (!showBuyActivateLinks) {
        /* More extensive logic can go here to build up the rules of what to show, but as we just have a
           on off right now let's keep it simple*/
        return <></>;
    }

    return (
        <>
            <Button
                appearance="primary"
                small
                onClick={toggleModal}
            >
                {importLicensesLabel}
            </Button>
            <Modal
                title={importLicensesLabel}
                show={open}
                onClose={toggleModal}
                className={classNames.modal}
                closeButton
            >
                {open && <LicenseImportSteps handleOnClose={toggleModal} />}
            </Modal>
        </>
    );
};

export default ImportLicensesModal;
